import { useState } from 'react'

import { useTranslation } from 'next-i18next'

import HeaderNavbar from '~/math-vault/components/HeaderNavbar'

import ROUTES from '~/shared/constants/routes.const'

import useTreasureTrail from '~/games/hooks/useTreasureTrail'
import GameWrapper from '~/games/components/GameWrapper'

function TreasureTrailPage(): React.ReactElement {
  const { t } = useTranslation('games')

  const [showTopbar, setShowTopbar] = useState(true)
  const { treasureTrailURL } = useTreasureTrail(setShowTopbar)

  return (
    <GameWrapper>
      <div className="w-screen h-screen">
        {showTopbar && <HeaderNavbar route={ROUTES.GAMES} title={t('treasureTrail.gameTitle')} />}
        <iframe className="w-full h-full absolute top-0" id="treasureTrailIframe" src={treasureTrailURL} />
      </div>
    </GameWrapper>
  )
}
export default TreasureTrailPage
